const RESERVED_TOP_LEVEL_SEGMENTS = new Set([
  "admin",
  "api",
  "assets",
  "avatars",
  "debug",
  "hub",
  "scene",
  "signin",
  "tokens",
  "whats-new"
]);

function normalizePath(pathname) {
  let path = pathname || "/";

  try {
    path = new URL(path, "https://metaverse.invalid").pathname;
  } catch {
    path = path.split("?")[0].split("#")[0];
  }

  return path.replace(/\/+$/, "") || "/";
}

function getFirstSegment(path) {
  return path.split("/").filter(Boolean)[0] || "";
}

export function classifyGlobalJourneyRoute(pathname) {
  const path = normalizePath(pathname);

  if (path === "/link") {
    return {
      track: true,
      pagePath: "/link",
      pageTitle: "Device Link",
      pageType: "device_link",
      appArea: "metaverse"
    };
  }

  const firstSegment = getFirstSegment(path);
  if (!firstSegment || RESERVED_TOP_LEVEL_SEGMENTS.has(firstSegment)) {
    return { track: false, reason: "not_allowlisted" };
  }

  if (path === `/${firstSegment}`) {
    return {
      track: true,
      pagePath: "/:sid",
      pageTitle: "Verse",
      pageType: "metaverse_room",
      appArea: "metaverse"
    };
  }

  if (path.startsWith(`/${firstSegment}/`)) {
    return {
      track: true,
      pagePath: "/:sid/*",
      pageTitle: "Verse",
      pageType: "metaverse_room_detail",
      appArea: "metaverse"
    };
  }

  return { track: false, reason: "not_allowlisted" };
}
